import styled from "styled-components";
import {
  MessageBar,
  MessageBarBody,
  Tooltip,
} from "@fluentui/react-components";
import { Info20Regular } from "@fluentui/react-icons";
import React, { useContext } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";

type Props = {
  className?: string;
};

export const ViewDescription = ({ className }: Props) => {
  const { selectedView } = useContext(ColumnOptionsContext);

  if (!selectedView?.userAppSettingDescription) return null;

  return (
    <Tooltip
      content={selectedView.userAppSettingDescription}
      relationship="description"
    >
      <StyledMessageBar
        intent="info"
        icon={<Info20Regular />}
        className={className}
      >
        <MessageBarBody style={{ width: "180px" }}>
          <DescriptionText>
            {selectedView.userAppSettingDescription}
          </DescriptionText>
        </MessageBarBody>
      </StyledMessageBar>
    </Tooltip>
  );
};

const StyledMessageBar = styled(MessageBar)`
  flex: 1;
  overflow: hidden;
`;

const DescriptionText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
`;
